<script setup>
import LandingHero from '@/components/landing/LandingHero.vue';
import LandingWhyCyberalarm from '@/components/landing/LandingWhyCyberalarm.vue';
import LandingHowItWorks from '@/components/landing/LandingHowItWorks.vue';
import LandingCourses from '@/components/landing/LandingCourses.vue';
import LandingAboutUs from '@/components/landing/LandingAboutUs.vue';
import LandingPrices from '@/components/landing/LandingPrices.vue';
import LandingAlarm from '@/components/landing/LandingAlarm.vue';
import LandingFeatures from '@/components/landing/LandingFeatures.vue';
import LandingHeroV2 from "@/components/landing/v2/LandingHeroV2.vue";
import LandingPartnersV2 from "@/components/landing/v2/LandingPartnersV2.vue";
import LandingThreatsV2 from "@/components/landing/v2/LandingThreatsV2.vue";
import LandingTrainingV2 from '@/components/landing/v2/LandingTrainingV2.vue';
import LandingVideoV2 from '@/components/landing/v2/LandingVideoV2.vue';
import LandingComparisonV2 from '@/components/landing/v2/LandingComparisonV2.vue';
import LandingBenefitsV2 from '@/components/landing/v2/LandingBenefitsV2.vue';
import LandingHowItWorksV2 from '@/components/landing/v2/LandingHowItWorksV2.vue';
import LandingStepsV2 from '@/components/landing/v2/LandingStepsV2.vue';
import LandingTestimonialsV2 from '@/components/landing/v2/LandingTestimonialsV2.vue';
import LandingFinalCtaV2 from '@/components/landing/v2/LandingFinalCtaV2.vue';
import LandingFAQV2 from '@/components/landing/v2/LandingFAQV2.vue';
import LandingNis2V2 from '@/components/landing/v2/LandingNis2V2.vue';
import FooterV2 from '@/components/landing/v2/FooterV2.vue';
</script>


<template>
  <section id="hero" class="mt-2">
    <LandingHeroV2 />
  </section>
  <section id="partners">
    <LandingPartnersV2 />
  </section>
  <section id="threats">
    <LandingThreatsV2 />
  </section>
  <section id="training">
    <LandingTrainingV2 />
  </section>
  <section id="video">
    <LandingVideoV2 />
  </section>
  <section id="comparison">
    <LandingComparisonV2 />
  </section>
  <section id="benefits">
    <LandingBenefitsV2 />
  </section>
  <section id="nis2">
    <LandingNis2V2 />
  </section>
  <section id="how-it-works">
    <LandingHowItWorksV2 />
  </section>
  <section id="steps">
    <LandingStepsV2 />
  </section>
  <section id="testimonials">
    <LandingTestimonialsV2 />
  </section>
  <section id="final-cta">
    <LandingFinalCtaV2 />
  </section>
  <section id="faq">
    <LandingFAQV2 />
  </section>
  <FooterV2 />
</template>
<!--
<template>
  <section
    id="top"
    class="mt-24"
  >
    <LandingHero />
  </section>

  <section
    class="pt-section"
    id="why-cyberalarm"
  >
    <LandingWhyCyberalarm />
  </section>
  <section id="how-it-works">
    <LandingHowItWorks />
    <LandingFeatures />
  </section>
  <section id="courses">
    <LandingCourses />
  </section>
  <section id="pricing">
    <LandingPrices />
  </section>
  <section id="research">
    <LandingAlarm />
  </section>
  <section id="about-us">
    <LandingAboutUs />
  </section>

</template>
-->


<style scoped></style>
